export enum EMonitorServiceContentDisplayerType {
    request = 'request',
    response = 'response',
}
